import { useState } from 'react';
import { Image as ImageIcon, X } from 'lucide-react'; // 👈 import the image icon

function TestimonialsBox(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTranslated, setIsTranslated] = useState(false);

    return (
        <div className='w-full p-5 justify-center border border-yellow text-black rounded-lg relative text-white'>
        <p><b>{props.name}</b></p>
            <p style={{ whiteSpace: 'pre-line' }}>{isTranslated ? props.translatedDescription : props.description}</p>

            {/* Translate Toggle Button */}
            <button 
                onClick={() => setIsTranslated(!isTranslated)}
                className="mt-3 px-4 py-2 text-black bg-yellow rounded transition hover:font-bold"
            >
                {isTranslated ? 'Show Original Text' : 'Translate'}
            </button>

            <button 
                onClick={() => setIsModalOpen(true)} 
                className="mt-3 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 transition flex items-center gap-2 hover:font-bold"
            >
                <ImageIcon className="w-5 h-5 text-white" />
                View Photo
            </button>

            {isModalOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                    onClick={() => setIsModalOpen(false)}
                >
                    <div 
                        className="relative bg-white rounded-lg max-w-2xl w-full max-h-[66vh] p-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close X button */}
                        <button 
                            onClick={() => setIsModalOpen(false)} 
                            className="absolute top-2 right-2 text-gray-600 hover:text-black"
                        >
                            <X className="w-6 h-6" />
                        </button>

                        {/* Image that fits modal height */}
                        <img 
                            className="w-full h-[60vh] object-contain rounded" 
                            src={props.image} 
                            alt="testimonialImageModal" 
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default TestimonialsBox
